import type { Task, Column } from '../types';

export function resolveFinishedColumnIdClient(
  finishedColumnId: string | null | undefined,
  columns: Column[] | undefined,
): string {
  if (finishedColumnId) return finishedColumnId;
  const cols = columns || [];
  const byId = cols.find((c) => c.id === 'done');
  if (byId) return byId.id;
  const byTitle = cols.find((c) => String(c.title || '').toLowerCase().trim() === 'done');
  return byTitle?.id || 'done';
}

/**
 * True when the task has dependencies and at least one is not in the project's "done" column.
 */
export function hasUnresolvedDependsOn(
  task: Pick<Task, 'dependsOn'> | null | undefined,
  tasksInProject: Task[],
  finishedColumnId: string | null | undefined,
  columns: Column[] | undefined,
): boolean {
  const raw = task?.dependsOn;
  if (!raw || raw.length === 0) return false;
  const doneId = resolveFinishedColumnIdClient(finishedColumnId, columns);

  for (const d of raw as any[]) {
    const id = typeof d === 'object' && d != null ? String(d._id ?? d.id ?? '') : String(d);
    if (!id) return true;
    const st =
      typeof d === 'object' && d != null && d.status != null
        ? d.status
        : tasksInProject.find((x) => x._id === id)?.status;
    if (st == null || st !== doneId) return true;
  }
  return false;
}
